import { Ionicons } from "@expo/vector-icons";

/**
 * Interface representing a product hint or tip for user onboarding and discovery.
 */
export interface IProductHint {
  id: string;
  title: string;
  description: string;
  category: string;
  iconName: keyof typeof Ionicons.glyphMap;
}

/**
 * Curated product hints and tips mirroring docs/user-hints-tips.md.
 */
export const PRODUCT_HINTS: IProductHint[] = [
  {
    id: "hint-multi-select",
    title: "Multi-Select Media to Build a Memory",
    description: "Select multiple photos and videos in My Media using checkboxes or Ctrl+Click on web, then tap 'Add to Memory' or 'Create Memory' to compile them into a shared story in seconds.",
    category: "Media & Memories",
    iconName: "images-outline",
  },
  {
    id: "hint-drag-drop",
    title: "Drag and Drop Files Anywhere",
    description: "On web and desktop, simply drag and drop images, audio clips, or videos directly anywhere onto the My Media page to begin immediate archival upload.",
    category: "Upload",
    iconName: "cloud-upload-outline",
  },
  {
    id: "hint-offline-capture",
    title: "Offline Capture & GPS Metadata",
    description: "Photos and videos captured using the built-in camera automatically extract creation date, camera metadata, and optional high-precision GPS coordinates so your timeline stays organized.",
    category: "Capture",
    iconName: "location-outline",
  },
  {
    id: "hint-send-to-pdf",
    title: "Send To & Export to PDF",
    description: "Use the Send To action on any memory or media item to share directly with other apps or export memories to clean, printable archival PDF documents.",
    category: "Sharing & Export",
    iconName: "paper-plane-outline",
  },
  {
    id: "hint-view-modes",
    title: "Quick Filtering and View Modes",
    description: "In My Media and My Memories, toggle between Details (Rows), Compact, Small, Medium, and Large views, and use the filter search bar to find memories instantly.",
    category: "Navigation",
    iconName: "grid-outline",
  },
  {
    id: "hint-sharing-controls",
    title: "Granular Sharing Controls",
    description: "Share items with individual contacts or custom groups as either Viewer (read-only) or Editor (collaborative), and revoke access at any time from the sharing control.",
    category: "Privacy & Security",
    iconName: "people-outline",
  },
  {
    id: "hint-collaborative-editing",
    title: "Collaborative Memory Editing",
    description: "Multiple people can collaborate on the same memory stories in real time with live synchronization and conflict-free rich text.",
    category: "Memories",
    iconName: "create-outline",
  },
  {
    id: "hint-bg-upload",
    title: "Background Upload Queue on Mobile",
    description: "Uploading multiple high-resolution photos on Android? Background uploads continue reliably even if you switch away from the screen.",
    category: "Mobile",
    iconName: "sync-outline",
  },
];
